var map = {
	"./abc.svg": "7ce4",
	"./bi.svg": "101c",
	"./bi_categories.svg": "5084",
	"./bot-error.svg": "b3ec",
	"./empty-state.svg": "ba56",
	"./insights_chart.svg": "bf60",
	"./kg.svg": "7951",
	"./machine_learning.svg": "40f7",
	"./under_construction.svg": "4b3c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5747";